type WaveProps = {
  fill: string;
  /** Dérive horizontale légère (section programme uniquement). */
  animated?: boolean;
};

const WAVE_TOP_PATH =
  'M0,58 C220,98 420,26 640,54 C860,82 1060,34 1280,62 C1360,74 1440,50 1440,58 L1440,0 L0,0 Z';

const WAVE_BOTTOM_PATH =
  'M0,32 C240,72 480,8 720,40 C960,72 1200,24 1440,56 L1440,96 L0,96 Z';

/** Tuile 1440px — bords gauche/droit alignés pour boucle sans couture (animation programme). */
const WAVE_TOP_TILE_PATH =
  'M0,58 Q180,94 360,58 Q540,22 720,58 Q900,94 1080,58 Q1260,22 1440,58 L1440,0 L0,0 Z';

const WAVE_BOTTOM_TILE_PATH =
  'M0,56 Q180,20 360,56 Q540,92 720,56 Q900,20 1080,56 Q1260,92 1440,56 L1440,96 L0,96 Z';

const WAVE_TILE_WIDTH = 1440;

function WaveSvg({ fill, path }: { fill: string; path: string }) {
  return (
    <svg viewBox="0 0 1440 96" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
      <path fill={fill} d={path} />
    </svg>
  );
}

/** Deux périodes dans un seul SVG — évite la ligne verticale entre deux blocs flex. */
function WaveSvgTiled({ fill, path }: { fill: string; path: string }) {
  return (
    <svg
      viewBox={`0 0 ${WAVE_TILE_WIDTH * 2} 96`}
      preserveAspectRatio="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path fill={fill} d={path} />
      <path fill={fill} d={path} transform={`translate(${WAVE_TILE_WIDTH} 0)`} />
    </svg>
  );
}

function WaveCap({
  position,
  fill,
  path,
  animated = false,
}: {
  position: 'top' | 'bottom';
  fill: string;
  path: string;
  animated?: boolean;
}) {
  const positionClass =
    position === 'top' ? 'public-section-wave__cap--top' : 'public-section-wave__cap--bottom';

  if (!animated) {
    return (
      <div className={`public-section-wave__cap ${positionClass}`} aria-hidden>
        <WaveSvg fill={fill} path={path} />
      </div>
    );
  }

  const tilePath = path === WAVE_TOP_PATH ? WAVE_TOP_TILE_PATH : WAVE_BOTTOM_TILE_PATH;

  return (
    <div
      className={`public-section-wave__cap ${positionClass} public-section-wave__cap--animated`}
      aria-hidden
    >
      <div className="public-section-wave__animated-track">
        <WaveSvgTiled fill={fill} path={tilePath} />
      </div>
    </div>
  );
}

/** Transition depuis la section au-dessus ; le fond de section apparaît sous la courbe. */
export function PublicSectionWaveTop({ fill, animated }: WaveProps) {
  return <WaveCap position="top" fill={fill} path={WAVE_TOP_PATH} animated={animated} />;
}

/** Transition vers la section en dessous ; le fond de section apparaît au-dessus de la courbe. */
export function PublicSectionWaveBottom({ fill, animated }: WaveProps) {
  return <WaveCap position="bottom" fill={fill} path={WAVE_BOTTOM_PATH} animated={animated} />;
}
